import { ROLES } from "../constants/roles";

export const MASTER_HOME = "/admin-master";

/** Empresa reservada ao usuário master (seed); não pode ser inativada. */
export const MASTER_COMPANY_ID = 1;

export const isMasterUser = (user) => user?.profile === ROLES.master;

export const isMasterCompany = (company) =>
	Number(company?.id) === MASTER_COMPANY_ID;

export const isMasterAllowedPath = (pathname) => {
	if (!pathname) return false;
	return pathname === MASTER_HOME || pathname.startsWith(`${MASTER_HOME}/`);
};
